<!--
 * @Description: 运维服务监测Top
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-25 14:19:02
 * @LastEditors: @Xin (834529118@qq.com)
 * @LastEditTime: 2021-08-05 09:37:42
 -->
<template>
  <div class="maintenance-top">
    <div class="protectDays">
      安全守护<span class="protectDaysValueItem" v-for="(item, index) in data.guardDays" :key="index">{{item}}</span>天
    </div>
    <div class="mileage">
      <div class="totalMileage">
        累计服务道路里程：<span class="value">{{data.mileageTotal}}</span>公里
      </div>
      <div class="newAddMileage">
        <div class="mileage">{{month}}月新增里程数：<span class="value">{{data.mileageMonth}}</span>&nbsp;公里</div>
        <!-- <div class="mileage">2月新增里程数：<span class="value">150</span>&nbsp;公里</div> -->
        <div class="compare">
          <div class="item">
            同比 <span :class="data.yearOnYear >= 0 ? 'el-icon-top' : 'el-icon-bottom'"></span> {{data.yearOnYear || 0}}%
            <!-- 同比 <span class='el-icon-top'></span> 40% -->
          </div>
          <div class="item">
            环比 <span :class="data.monthOnMonth >= 0 ? 'el-icon-top' : 'el-icon-bottom'"></span> {{data.monthOnMonth || 0}}%
            <!-- 环比 <span class='el-icon-top'></span> 25% -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'maintenanceTop',
  components: {
  },
  data () {
    return {
      data: {},
      month: new Date().getMonth() + 1
    }
  },
  methods: {
    /**
     * @description                   获取汇总数据
     * @return {undefied}             无返回值
     */
    getData () {
      this.$http.get('/rest/screen/operation/top/summary')
        .then(res => {
          if (res.code === 0) {
            this.data = res.data
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
  },
  created () {
    this.getData()
  },
}
</script>

<style lang="less" scoped>
  .maintenance-top {
    width: 100%;
    height: 100%;
    >div {
      width: 100%;
      text-align: center;
    }
    .protectDays {
      font-size: 31px;
      color: #fff;
      margin-bottom: 40px;
      .protectDaysValueItem {
        display: inline-block;
        font-size: 40px;
        background: #108484;
        border: solid 1px #1f99bb;
        width: 40px;
        text-align: center;
        margin: 0 10px;
        padding: 10px 5px;
      }
    }
    .mileage {
      display: inline-flex;
      justify-content: space-around;
      >div {
        background: url('/static/img/layout/overviewProductBg.png');
        background-size: 100% 100%;
        width: 318px;
        height: 90px;
        font-size: 18px;
      }
      .totalMileage {
        color: #00fcf0;
        line-height: 80px;
        .value {
          font-size: 30px;
          font-weight: bold;
          color: #e4ee0c;
        }
      }
      .newAddMileage {
        .mileage {
          color: #00fcf0;
          margin-bottom: 10px;
          line-height: 40px;
          .value {
            font-size: 30px;
            font-weight: bold;
          }
        }
        .compare {
          .item {
            display: inline-block;
            font-size: 15px;
            color: #fff;
            margin-right: 20px;
            .el-icon-top {
              color: #d92626;
              font-weight: bold;
              font-size: 16px;
            }
            .el-icon-bottom {
              color: #16c840;
              font-weight: bold;
              font-size: 16px;
            }
          }
        }
      }
    }
  }
</style>
